import styled from 'styled-components';

export const FileInput = styled.input`
  margin-left: 10px;
`;

export default FileInput;
